export default "__VITE_ASSET__BgOtqW_c__"